import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import ButtonLoader from '../../../components/common/buttonLoader/ButtonLoader';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.09,
        flex: 0.9,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "minimumStock",
        headerName: "Minimum stock",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "mrsQty",
        headerName: "MRS quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "inquiryQty",
        headerName: "Inquiry quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "poQty",
        headerName: "PO quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "qcQty",
        headerName: "QC quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "storeQty",
        headerName: "Store quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "occupyQuantity",
        headerName: "Occupy quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "workPlanningQty",
        headerName: "Work planning quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rejectQty",
        headerName: "Reject quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "issueQty",
        headerName: "Issue quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "requiredQuantity",
        headerName: "Required quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "totalRequiredQuantity",
        headerName: "Total required quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "mrsQuantity",
        headerName: "MRS quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "piQuantity",
        headerName: "PI quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
];

export const CalculatePlanningPopup = (props) => {
    return (
        <ModalBasic
            id="material-planing"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[20px]'>
                <span className="text-blue text-[16px] font-semibold">Calculate planning selection</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp col-span-2'>
                        <label>Select customer</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.materialObject.CustomerList}
                            value={props.materialObject.idCustomer ? props.materialObject.CustomerList.find(x => x.value === props.materialObject.idCustomer) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idCustomer")
                            }
                            className={props.validState?.error?.idCustomer !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select work order</label>
                        <MultiSelectDropdown
                            drpIdentity="Select supplier"
                            options={props.materialObject.workOrderList}
                            value={props.materialObject.idWorkOrder ? props.materialObject.workOrderList.find(x => x.value === props.materialObject.idWorkOrder) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idWorkOrder")
                            }
                            className={props.validState?.error?.idWorkOrder !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='btn-grp flex gap-2.5'>
                        {props.isLoading ?
                            <ButtonLoader />
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.click_AddBomData()}>Add bom data</button>
                        }
                        <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clear()}>Clear</button>
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className="process-table h-[55vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.dtMaterialPlanning}
                            columnDefs={itemColdefs}
                            headerHeight={60}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-2.5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}